import { render, staticRenderFns } from "./PerformanceAttributionList.vue?vue&type=template&id=15d9d700&scoped=true&"
import script from "./PerformanceAttributionList.vue?vue&type=script&lang=js&"
export * from "./PerformanceAttributionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d9d700",
  null
  
)

export default component.exports